export let resources = (state = resources, action) => {
    switch (action.type) {
        case "REQUEST_RESOURCES":
            return {};
        case "RECEIVE_RESOURCES":
            return action.resources;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/resources.js